import { Link } from 'react-router-dom';
import { LanguageSwitch } from '../../app/language-switch';
import { useLanguage } from '../../core/hooks/use-language';
import { useTranslation } from '../../core/hooks/use-translation';
import { BrandLogo } from '../home/brand-logo';
import { ChevronLeftIcon } from './policy-icons';

/**
 * The legal page's header: the mark, the language switch and a way back.
 *
 * It is the site header's own 72px bar — `site.css` already carries every rule the live page
 * repeats inline — with the marketing navigation left off, which is what the live page does. Below
 * 600px the back button keeps its arrow and drops its word, so the three controls stay on one row.
 */
export function PolicyHeader() {
    const { t } = useTranslation();
    const language = useLanguage();

    return (
        <header className="header">
            <div className="header-inner">
                <Link to={`/${language}`} className="logo">
                    <BrandLogo />
                </Link>

                <div className="header-actions">
                    <LanguageSwitch />
                    <Link to={`/${language}`} className="btn-back">
                        <ChevronLeftIcon />
                        <span>{t('policy.nav.back')}</span>
                    </Link>
                </div>
            </div>
        </header>
    );
}
